<template>
  <b-card class="mt-3">
    <validation-observer ref="observer">
      <template v-if="hold">
        <labeled-wrapper :label="$t('details') | capitalize">
          <b-row>
            <b-col>
              <distribution-detail-field
                :label="$t('created_by') | capitalize" :value="hold.createdByName"
              />
            </b-col>
            <b-col>
              <distribution-detail-field
                :label="$t('created_on') | capitalize"
                :value="createdAtValue"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <distribution-detail-field
                :label="$t('reason') | capitalize"
                :value="hold.reason"
                :edit-mode="createMode"
                vid="reason"
                ref="reason"
                rules="required"
              >
                <template v-slot:input="{ state }">
                  <b-form-textarea required v-model="hold.reason" :state="state"/>
                </template>
              </distribution-detail-field>
            </b-col>
          </b-row>
          <b-row v-if="type==='recording'">
            <b-col>
              <distribution-detail-field
                :label="$t('college_type') | capitalize"
                :value="getCollegeType(hold.collegeType)"
                :edit-mode="createMode"
                vid="collegeType"
                ref="collegeType"
                rules="required"
              >
                <template v-slot:input="{ state }">
                  <b-form-select
                    required
                    v-model="hold.collegeType"
                    :state="state"
                    :options="[
                      { value: 'maker', text: 'Maker' },
                      { value: 'performer', text: 'Performer' },
                      { value: 'maker_and_performer', text: 'Both' }
                    ]"></b-form-select>
                </template>
              </distribution-detail-field>
            </b-col>
          </b-row>
        </labeled-wrapper>
        <div class="d-flex justify-content-center" v-if="!createMode && canDelete">
          <b-button class="btn-secondary" @click="$bvModal.show('hold-delete-modal')">
            {{ $t('delete_hold') | capitalize }}
          </b-button>
        </div>
      </template>
      <div class="d-flex justify-content-center" v-if="!hold">
        <b-button v-if="canCreate" class="btn-secondary" @click="create">
          {{ $t('create_hold') | capitalize }}
        </b-button>
      </div>
    </validation-observer>
    <b-row class="fixed-footer" >
      <b-col class="d-flex justify-content-end" style="padding: 25px">
        <b-button v-if="createMode" class="btn-outline-dark" @click="cancel">{{ $t("cancel") | capitalize }}</b-button>
        <b-button
          class="ml-3 btn-outline-red"
          :disabled="!valid"
          @click="submit"
          v-if="createMode"
        >
          {{ $t("save") | capitalize }}
        </b-button>
      </b-col>
    </b-row>
    <modal
      id="hold-delete-modal"
      :customTitle="'Delete hold' | capitalize"
      modal-class="custom-modal edit"
      modalType="edit"
      size="md"
      centered
      @ok="deleteHold"
      okTitle="Confirm"
    >
      <div>{{ $t('delete_hold_confirm') | capitalize }}</div>
    </modal>
  </b-card>
</template>


<script>
import { mapActions, mapState } from "vuex"
import DistributionDetailField from "./DistributionDetailField.vue"
import LabeledWrapper from "./LabeledWrapper.vue"
import { Pages } from "@/utils/pages"
import { ValidationObserver } from "vee-validate"
import parseDate from "@/utils/date-parser"

export default {
  name: "HoldDetails",
  components: { DistributionDetailField, LabeledWrapper, ValidationObserver },
  props: {
    type: String,
    targetId: String,
  },
  data () {
    return {
      hold: null,
      createMode: false,
    }
  },
  computed: {
    ...mapState("user", ["permissions"]),
    valid () {
      return this.$refs.observer.flags.valid
    },
    createdAtValue () {
      return this.hold?.createdAt ? parseDate(this.hold.createdAt, this.$config.DATETIME_FORMAT) : "-"
    },
    canCreate () {
      return this.permissions.pages[Pages.HoldDetails].canWrite
    },
    canDelete () {
      return this.permissions.actions.canRemoveHold
    }
  },
  methods: {
    ...mapActions("alert", ["success", "error"]),
    create () {
      this.hold = {
        active: true,
        type: this.type,
        targetId: this.targetId,
      }
      this.createMode = true
    },
    deleteHold () {
      this.$api.holds.deleteHold(this.hold.id)
        .then(() => {
          this.hold = null
        })
        .catch(error => {
          this.error(error)
        })
    },
    cancel () {
      this.createMode = false
      this.hold = null
    },
    submit () {
      this.createMode = false
      this.$api.holds.createHold(this.hold)
        .then((result) => {
          const holdId = result.data.id
          this.$api.holds.getHold(this.type, this.targetId).then((result) => {
            this.hold = result.data
            this.hold.id = holdId
          })
        })
        .catch(error => {
          this.error(error.response.data)
        })
    },
    getCollegeType (collegeType) {
      switch (collegeType) {
      case "maker":
        return "Maker"
      case "performer":
        return "Performer"
      case "maker_and_performer":
        return "Both"
      default:
        return ""
      }
    }
  },
  mounted () {
    this.$api.holds.getHold(this.type, this.targetId)
      .then((result) => {
        if (result.status === 204) {
          // no active hold
          return
        }
        this.hold = result.data
      })
      .catch(error => {
        this.error(error.response.data)
      })
  }
}
</script>
